import React, {Component} from 'react';
import {
  Row,
  Col,
  Button,
  Tabs,
  Nav,
  Tab,
  Table,
  Modal,
  Image,
  Container,
} from 'react-bootstrap';
import {appConfig} from '../../config';

var dateFormat = require('dateformat');

class PaymentsView extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    console.log(this.props.paymentDetail);

    const data =
      this.props.paymentDetail && this.props.paymentDetail.item
        ? this.props.paymentDetail && this.props.paymentDetail.item
        : null;

    return (
      <div>
        <div className="modelboxdesigns">
          <Modal
            show={this.props.show}
            onHide={this.props.close}
            animation={false}
            //size="lg"
            backdrop="static"
            style={{backgroundColor: '#00000010'}}
          >
            <Modal.Header
              style={{
                fontSize: '35px',
                backgroundColor: '#1768B7',
                color: 'white',
              }}
              closeButton
            >
              <Modal.Title>
                <span style={{fontSize: '20px'}}>Receipt Details</span>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div className="profilebasicdetailscont">
                {/* <Row>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <div>
                      <p className="profilebasicdetailscontname">
                        Reference Number{" "}
                      </p>
                      <p className="profilebasicdetailscontper">
                        {data !== null && data.invNo}
                      </p>
                    </div>
                  </Col>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <div>
                      <p className="profilebasicdetailscontname">
                        Order Number
                      </p>
                      <p className="profilebasicdetailscontper">
                        {data && data.orderId && data.orderId.orderNo}
                      </p>
                    </div>
                  </Col>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <div>
                      <p className="profilebasicdetailscontname">
                        Paid By
                      </p>
                      <p className="profilebasicdetailscontper">
                        {data && data.userCmstDtls && data.userCmstDtls.name}
                      </p>
                    </div>
                  </Col>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <div>
                      <p className="profilebasicdetailscontname">
                        Paid To
                      </p>
                      <p className="profilebasicdetailscontper">
                        {data && data.recptDtls && data.recptDtls.name}
                      </p>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <div className="basicdetailscontprof">
                      <p className="profilebasicdetailscontname">
                        Payment Type
                      </p>
                      <p className="profilebasicdetailscontper">
                        {data && data.orderId && data.orderId.payType}
                      </p>
                    </div>
                  </Col>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <div className="basicdetailscontprof">
                      <p className="profilebasicdetailscontname">Amount</p>
                      <p className="profilebasicdetailscontper">
                        {data !== null && data.paidAmnt?"INR "+data.paidAmnt:null}
                      </p>
                    </div>
                  </Col>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <div className="basicdetailscontprof">
                      <p className="profilebasicdetailscontname">
                        Created Date & Time
                      </p>
                      <p className="profilebasicdetailscontper">
                        {data !== null &&
                          data.createdAt !== null &&
                          dateFormat(data.createdAt, "mmmm dS, yyyy, h:MM TT")}
                      </p>
                    </div>
                  </Col>
                </Row> */}

                <Row>
                  <Col xs={12} sm={12} md={12} lg={12}>
                    <Row>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <p className="profilebasicdetailscontname">
                          Reference Number
                        </p>
                      </Col>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <p className="cmn_Cap">
                          {data !== null && data.invNo}
                        </p>
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <p className="profilebasicdetailscontname">
                          Order Number
                        </p>
                      </Col>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <p className="cmn_Cap">
                          {data && data.orderId && data.orderId.orderNo}
                        </p>
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <p className="profilebasicdetailscontname">Pharmacy</p>
                      </Col>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <p className="cmn_Cap">
                          {data && data.userCmstDtls && data.userCmstDtls.name}
                        </p>
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <p className="profilebasicdetailscontname">
                          Distributor
                        </p>
                      </Col>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <p className="cmn_Cap">
                          {data && data.recptDtls && data.recptDtls.name}
                        </p>
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <p className="profilebasicdetailscontname">
                          Payment Mode
                        </p>
                      </Col>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <p className="cmn_Cap">
                          {data && data.orderId && data.orderId.payMode}
                        </p>
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <p className="profilebasicdetailscontname">Amount</p>
                      </Col>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <p className="cmn_Cap">
                          {data !== null && data.paidAmnt
                            ? 'INR ' + data.paidAmnt
                            : null}
                        </p>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <p className="profilebasicdetailscontname">
                          Payment Status
                        </p>
                      </Col>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <p className="cmn_Cap">
                          {data !== null && data.status}
                        </p>
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <p className="profilebasicdetailscontname">
                          Created Date & Time
                        </p>
                      </Col>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <p className="cmn_Cap">
                          {data !== null &&
                            data.createdAt !== null &&
                            dateFormat(data.createdAt, 'dd/mm/yyyy, h:MM TT')}
                        </p>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      </div>
    );
  }
}

export default PaymentsView;
